import { MouseSensor, TouchSensor, useSensor, useSensors } from "@dnd-kit/core"

const DRAG_ACTIVATION_DISTANCE = 6

/**
 * The organizer's shared dnd-kit sensor setup: mouse + touch, with a small
 * activation distance so a plain click (e.g. selecting a category) doesn't
 * start a drag.
 */
export function useLayerOrganizeDragSensors() {
  return useSensors(
    useSensor(MouseSensor, {
      activationConstraint: { distance: DRAG_ACTIVATION_DISTANCE },
    }),
    useSensor(TouchSensor, {
      activationConstraint: { distance: DRAG_ACTIVATION_DISTANCE },
    }),
  )
}
